import type { ComputedRef } from 'vue'
import { EdbTagID } from '@/types/api'

const SEARCH_BAR_FILTER_NAMES = ['date', 'headcount']
const SEARCH_BAR_CATEGORY_TAG_IDS = [EdbTagID.TagIDRestaurant, EdbTagID.TagIDBar, EdbTagID.TagIDTakeout]

export function useRegionSearchBarVisibility(
  filters: ComputedRef<{ components?: { name: string }[] } | undefined>,
  firstLevelCategory: ComputedRef<{ category_tags?: { id: number }[] } | undefined>
) {
  const shouldShowRegionSearchBar = computed(() => {
    const components = filters.value?.components || []
    const hasRequiredFilter = SEARCH_BAR_FILTER_NAMES.every(name => components.some(c => c.name === name))
    const categoryTags = firstLevelCategory.value?.category_tags || []
    const hasRequiredTag = SEARCH_BAR_CATEGORY_TAG_IDS.some(id => categoryTags.some(tag => tag.id === id))
    return hasRequiredFilter && hasRequiredTag
  })

  const nuxtApp = useNuxtApp()

  onMounted(() => {
    if (!shouldShowRegionSearchBar.value) {
      nuxtApp.$store.dispatch('setEmbeddedSearchBarVisible', false)
    }
  })

  onUnmounted(() => {
    nuxtApp.$store.dispatch('setEmbeddedSearchBarVisible', false)
  })

  return { shouldShowRegionSearchBar }
}
